import { useDispatch } from 'react-redux';
import { useState } from 'react';

import { FileUploadIcon } from '../../icons/FileUploadIcon';
import { InfoTitle } from '../../common/InfoTooltip/InfoTitle';
import { GotoProductFeedsModal } from '../../modals/GotoReportsPageModal';
import { UploadProductsFeedsModal } from '../../modals/UploadProductsFeedsModal';
import { PRODUCT_FEEDS_SET_DIALOG } from '../../../store/reducers/productsFeeds';

import styles from './CatalogueManagementActions.module.scss';

export function CatalogueManagementActions() {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className={styles.actionsWrapper}>
        <InfoTitle content="Upload Products Data">
          <button type="button" className={styles.button} onClick={() => setIsModalOpen(true)}>
            <FileUploadIcon />
          </button>
        </InfoTitle>
      </div>

      <UploadProductsFeedsModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onUpload={() => {
          dispatch({ type: PRODUCT_FEEDS_SET_DIALOG, payload: { gotoProductFeedsModal: true } });
        }}
      />
      <GotoProductFeedsModal
        content={
          <span>
            The Product Upload Report is being emailed to you and will
            <br />
            soon be available on the
          </span>
        }
      />
    </>
  );
}
